export default __webpack_public_path__ + "static/media/918.583037b3.png";